// App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Dashboard from './Components/Pages/Dashboard';
import Signup from './Components/Auth/Signup';
import ForgotPassword from './Components/Auth/ForgotPassword';
import Emailverification from './Components/Auth/emailverification';
import ResetPassword from './Components/Auth/ResetPassword';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import Whatsapplogin from './Components/Auth/Whatsapplogin';
import PasswordChange from './Components/Auth/PasswordChange';



function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot+password" element={<ForgotPassword />} />
        <Route path='/verification' element={<Emailverification />} />
        <Route path='/reset-password/:resetToken' element={<ResetPassword />} />
        <Route path='/whatsapplogin' element={<Whatsapplogin />} />
        
        <Route path='/passwordchange' element={<PasswordChange />} />

        <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
